import urlApi from '../../router/urlApi'
import { Serialize } from '../../services/serializeFormData'
// import { LoadFormData } from '../../services/LoadFormData'
import Vue from 'vue'
import Toast from 'vue-toasted'
import router from '../../router'
// import Tracking from 'tracking'

const toastOptions = {
  theme: 'none',
  position: 'bottom-center',
  className: 'vuestic-toast',
  iconPack: 'fontawesome',
  duration: 5000
}

Vue.use(Toast, toastOptions)
export default {
  startTime () {
    let self = this
    var time = new Date()
    var y = time.getFullYear()
    var mon = time.getMonth() + 1
    var d = time.getDate()
    var h = time.getHours()
    var min = time.getMinutes()
    var s = time.getSeconds()

    mon = self.checktime(mon)
    d = self.checktime(d)
    h = self.checktime(h)
    min = self.checktime(min)
    s = self.checktime(s)

    var now = d + '/' + mon + '/' + y + '   ' + h + ':' + min + ':' + s

    if (document.getElementById('clock')) {
      document.getElementById('clock').innerHTML = now
    }

    setTimeout(function () {
      self.startTime()
    }, 1000)
  },

  checktime (i) {
    if (i.toString().length < 2) {
      i = '0' + i
    }
    return i
  },

  storeFoto () {
    // let self = this

    Vue.http.post(urlApi + '/aulas/praticas/anotacao', Serialize.withFormData('form_fotos_teoricas')).then((response) => {
      console.log(response)
    }).catch((response) => {
      console.log(response)
    })
  },

  launchToast (icon, msg) {
    Vue.toasted.show(msg, {
      icon: icon,
      position: 'top-right',
      duration: 5000,
      fullWidth: false
    }
    )
  },

  getAula (callback, sala) {
    let self = this
    var time = new Date()
    // var time = new Date(2019, 3, 1, 15, 50, 0, 0);
    var y = time.getFullYear()
    var mon = time.getMonth() + 1
    var d = time.getDate()
    var h = time.getHours()
    var min = time.getMinutes()
    var s = time.getSeconds()

    mon = self.checktime(mon)
    d = self.checktime(d)
    h = self.checktime(h)
    min = self.checktime(min)
    s = self.checktime(s)

    var now = d + '-' + mon + '-' + y + '   ' + h + ':' + min + ':' + s

    Vue.http.get(urlApi + '/aulas/teoricas/cfc/' + sala.cfc + '/sala/' + sala.id + '/foto/' + now).then((response) => {
      // console.log(response)
      callback(response.data.dados)
    }).catch((response) => {
      console.log(response)
    })
  },

  getAulaTeorica (callback, sala) {
    // let self = this
    // var time = new Date();
    // // var time = new Date(2019, 3, 1, 15, 50, 0, 0);
    // var y = time.getFullYear();
    // var mon = time.getMonth()+1;
    // var d = time.getDate();
    // var h = time.getHours();
    // var min = time.getMinutes();
    // var s = time.getSeconds();

    // mon = self.checktime(mon);
    // d = self.checktime(d);
    // h = self.checktime(h);
    // min = self.checktime(min);
    // s = self.checktime(s);

    // var now = d + '-' + mon + '-' + y + '   ' + h + ':' + min + ':' + s;

    Vue.http.get(urlApi + '/aulas/teoricas/cfc/' + sala.cfc + '/sala/' + sala.id).then((response) => {
      // console.log(response)
      callback(response.data.dados)
    }).catch((response) => {
      // console.log(response)
    })
  },

  getEntidades (callback, sala) {
    Vue.http.get(urlApi + '/aulas/teoricas/cfc/' + sala.cfc + '/sala/' + sala.id).then((response) => {
      callback(response.data.dados)
    }).catch((response) => {
      console.log(response)
    })
  },

  getSalas (callback) {
    Vue.http.get(urlApi + '/aulas/salas').then((response) => {
      console.log(response)
      callback(response.data)
    })
  },

  getSalasVirtuais (callback) {
    Vue.http.get(urlApi + '/aulas/salas/virtual/page').then((response) => {
      callback(response.data)
    })
  },

  getTurmas (callback) {
    Vue.http.get(urlApi + '/turmas').then((response) => {
      callback(response.data)
    })
  },

  updateFoto (idFotoTeorica, idStatus) {
    Vue.http.get(urlApi + '/aulas/teoricas/fotos/' + idFotoTeorica + '/' + idStatus).then((response) => {
      console.log(response)
    }).catch((response) => {
      console.log(response)
    })
  },

  removeFoto (instanciaVue, cfc, id_turma_teorica, id_aula_teorica, idFotoTeorica) {

    let self = this;

    Vue.http.post(urlApi + '/aulas/teoricas/removerFoto', {'cfc' : cfc, 'turma' : id_turma_teorica, 'aula' : id_aula_teorica, 'foto' : idFotoTeorica}
    ).then((response) => {

      instanciaVue.atualizar();

      if(instanciaVue.$refs.smallModal)
        instanciaVue.$refs.smallModal.close()

      self.launchToast('fa-check', response.body.mensagem);
      
    }).catch((response) => {
      self.launchToast('fa-exclamation-triangle', response.body.mensagem);
    })
  },

  updateFotoEntidadeInstrutor (idInstrutor, idStatus, idAulaTeorica) {
    Vue.http.get(urlApi + '/aulas/teoricas/aula/instrutor/' + idInstrutor + '/' + idStatus + '/' + idAulaTeorica).then((response) => {
      console.log(response)
    }).catch((response) => {
      console.log(response)
    })
  },

  updateFotoEntidade (idAluno, idStatus, idAulaTeorica) {
    Vue.http.get(urlApi + '/aulas/teoricas/aula/aluno/' + idAluno + '/' + idStatus + '/' + idAulaTeorica).then((response) => {
      console.log(response)
    }).catch((response) => {
      console.log(response)
    })
  },

  updateFotoTodas (idAula, type) {
    Vue.http.get(urlApi + '/aulas/teoricas/classificar/aula/' + idAula + '/' + type).then((response) => {
      console.log(response)
    }).catch((response) => {
      console.log(response)
    })
  },

  getRelatorio (callback) {
    // let self = this

    Vue.http.post(urlApi + '/aulas/teoricas/relatorio', Serialize.withFormData('form_relatorio')).then((response) => {
      callback(response.data.dados)
    }).catch((response) => {
      console.log(response)
    })
  },
  paginaSala (idSala) {
    router.push({ name: 'ver-sala', params: { idSala: idSala } })
  },
  paginaSalaMaximizada (idSala) {
    router.push({ name: 'ver-sala-max', params: { idSala: idSala } })
  },

  paginaSalaTeorica (idSala) {
    router.push({ name: 'ver-sala-teorica', params: { idSala: idSala } })
  }

}
